import { nanoid } from 'nanoid';

export default {
  mounted() {
    this.checkForSidebarDraftPage();
  },
  methods: {
    addDraftPageAndUpdateSidebar(project, parent = 'root', draftExists = false) {
      const localPageId = draftExists ? this.$store.getters.sidebarDraftPage.id : nanoid(6);
      this.$store.dispatch('setParentPageIdForAdd', 'root');
      const newPage = {
        title: '',
        content: '',
        project_id: project.id,
        id: localPageId,
      };
      this.$store.dispatch('setSidebarPageDraft', {
        id: localPageId,
        projectId: project.id,
        parent,
      });
      this.$store.dispatch('addPageToFlatPages', newPage);
      this.$store.dispatch('localAddPageInPageTree', {
        projectId: project.id,
        pageId: localPageId,
      });

      this.$store.dispatch('setNewPageCreating', true);
      this.$store.dispatch('setSelectedProjectId', '');
      if (this.$route.path === `/${this.teamSlug}/${this.$cons.projectSlug}-${project.id}/newpage`)
        return;
      this.$store.dispatch('setPage', { content: '', collaboration: { token: 'newpage' } });
      this.$store.dispatch('setCurrentPageID', 'newpage');
      this.$router.push(`/${this.teamSlug}/${this.$cons.projectSlug}-${project.id}/newpage`);
      this.expandProject(true, project);
    },

    expandProject(value, project) {
      this.$store.dispatch('setExpandedProject', {
        id: `${this.teamSlug}-${project.id}`,
        value,
      });
    },

    checkForSidebarDraftPage() {
      if (
        this.project?.id === this.$store.getters.sidebarDraftPage.projectId &&
        this.$route.name === 'newpage'
      ) {
        this.addDraftPageAndUpdateSidebar(
          this.project,
          this.$store.getters.sidebarDraftPage.parent,
          true
        );
      }
    },
  },

  computed: {
    teamSlug() {
      return this.$store.getters.getTeamSlug;
    },
  },
};
